<template>
  <Dropdown
    ref="dropdown"
    class="calendar-filter_selected dropdown-bordered"
    :close-on-click="closeOnClick"
    :scroll-shadow="scrollShadow"
    :full-width="fullWidth"
    @hide="$emit('hide')"
    @show="$emit('show')"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <template #trigger="{ toggle, isOpen }">
      <div class="flex w-full">
        <button
          class="btn grow"
          type="button"
          :class="[darkFilter ? 'dark-filter' : '', triggerClass]"
          @click="toggle"
        >
          <span class="dropdown-toggle__label mx-1 sm:mx-2 xl:mx-3">
            <slot name="toggle" />
          </span>
          <div
            class="icon-dropdown"
            :class="darkFilter ? 'dark-filter' : ''"
          >
            <fa :icon="isOpen ? 'chevron-up' : 'chevron-down'" />
          </div>
        </button>
      </div>
    </template>
    <template #content>
      <div
        class="w-full"
        :class="{ 'bg-white': !scrollShadow }"
      >
        <slot name="options" />
      </div>
    </template>
  </Dropdown>
</template>

<script>
export default defineNuxtComponent({
  props: {
    closeOnClick: {
      type: Boolean,
      default: true,
    },

    scrollShadow: {
      type: Boolean,
      default: false,
    },

    darkFilter: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: true,
    },

    triggerClass: {
      type: [String, Object],
      default: '',
    },
  },

  expose: ['hide'],

  emits: ['open', 'hide', 'show', 'close'],

  methods: {
    hide () {
      this.$refs?.dropdown?.close()
    },
  },
})
</script>

<style lang="scss">
.dropdown-toggle__label {
  @media all and (max-width: theme('screens.sm')) {
    font-size: .8em;
  }
}
</style>
